import React from 'react';
import DefaultResources from '../../../../../Templates/DefaultResources';
import DefaultWorkflows from '../../../../../Templates/DefaultWorkflows';
import DataGrid, {
    Editing,
    Column,
    Lookup,
    RequiredRule
} from 'devextreme-react/data-grid';
import { GetManualActionTypes } from '../../../../../shared/lookup';
import Common from '../../../../../shared/common';
import { FormattedMessage, injectIntl } from "react-intl";

const availableActions = ["CREATE", "CLEAR"];
const availableParties = ["PM", "SUPPLIER", "SUPERVISOR", "CLIENT"];

export const validatePostActionRecord = (data, availableActionOptions, e) => {
    const valResult = { isValid: true, errorText: '' };
    try {

        if(!availableActions.includes(data.action)){
            valResult.errorText = "Invalid action";
            valResult.isValid = false;
        }

        const actionType = availableActionOptions.find(actT => actT.value === data.actionType);


        if (!actionType) {
            valResult.errorText = "Invalid action type";
            valResult.isValid = false;
        }

        if (!data.timePeriod) {
            valResult.errorText = "Time Period selection is required";
            valResult.isValid = false;
        }

        if (data.action === "CREATE") {
            if (data.timePeriod === "NONE") {
                valResult.errorText = "Time Period \"NONE\" can not be selected for CREATE Actions";
                valResult.isValid = false;
            }
        }

        if (data.action === "CLEAR") {
            if (data.timePeriod !== "NONE") {
                valResult.errorText = "Time Period has to be \"NONE\" for CLEAR Actions";
                valResult.isValid = false;
            }
            if (data.daysForAction) {
                valResult.errorText = "Days can only be 0 for CLEAR actions";
                valResult.isValid = false;
            }
        }

        if (data.timePeriod !== "CUSTOM") {
            if (data.daysForAction) {
                valResult.errorText = "Days can only be 0 for given time period!";
                valResult.isValid = false;
            }
        }

        if (!data.ownerParty) {
            valResult.errorText = "Owner Party is required!";
            valResult.isValid = false;
        }
        if (data.daysForAction < 0 || data.daysForAction > 1000) {
            valResult.errorText = "Days to create the action can be between 0 and 1000!";
            valResult.isValid = false;
        }
    } catch (err) {
        try { valResult.errorText = err.toString(); } catch (err2) { }
        valResult.isValid = false;
    }


    return valResult;
}
class PostActionsGrid extends React.Component {
    constructor(props) {
        super(props);
        this.gridRef = React.createRef();
        const initialList = props.postActionsList ? JSON.parse(JSON.stringify(props.postActionsList)) : [];
        const availableResources = DefaultResources.filter(rsc => rsc.type === "NUMBER").map(rsc => rsc.key)
        this.timePeriodOptions = ["NONE", ...availableResources, "ASK_ON_FORM", "CUSTOM"];
        const availableActionOptions = this.getActionOptions();
        this.state = {
            items: initialList,
            availableActionOptions
        };
    }
    getActionOptions = () => {
        let actionTypes = DefaultWorkflows.reduce((wfArray, wfg) => {
            let notifyPossibleWFs = wfg.workflows.filter(wf => (!!wf.config.notifyPossible && (!this.props.wfid || this.props.wfid === wf.id)));
            if (notifyPossibleWFs.length > 0) {
                wfArray.push(
                    ...notifyPossibleWFs.map(wf => ({
                        value: 'WF_' + wf.id,
                        display: `[${Common.Lpad(wf.id, 2)}] ${wf.config.description}`,
                        wfid: wf.id
                    }))
                );
            }
            return wfArray;
        }, []);
        const manualActionTypes = GetManualActionTypes(this.props.intl);
        if (!this.props.wfid) {
            actionTypes = actionTypes.concat(manualActionTypes);
        }

        actionTypes = actionTypes.sort((a, b) => a.display.localeCompare(b.display));
        return actionTypes;
    }
    // componentDidMount() {
    //     console.log("PostActionsGrid Mounted")
    // }
    // componentWillUnmount() {
    //     console.log("PostActionsGrid Un-Mounted")
    // }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.postActionsList !== this.props.postActionsList || prevProps.wfid !== this.props.wfid) {
            const availableActionOptions = this.getActionOptions();
            this.setState({
                items: this.props.postActionsList ? JSON.parse(JSON.stringify(this.props.postActionsList)) : [],
                availableActionOptions
            });
        }
    }
    onRowValidating = async (e) => {
        e.promise = new Promise((resolve, reject) => {
            const newObject = { ...e.oldData, ...e.newData };

            const valResult = validatePostActionRecord(newObject, this.state.availableActionOptions, e)

            e.errorText = valResult.errorText;
            e.isValid = valResult.isValid;

            if (valResult.isValid && e.oldData?.actionType !== newObject.actionType) {
                //IF ACTION TYPE CHANGED
                if (this.state.items.some(itm => itm.actionType === newObject.actionType && itm.action === newObject.action)) {
                    e.errorText = "Action Type already exist!";
                    e.isValid = false;
                }
            }

            //DONT CHANGE STATUS IN OTHER CASES
            resolve();
        });
    }

    updateParentList = (e) => {
        const source = e.component.getDataSource();
        if (source._items) {
            //remove auto generated ID Key
            source._items.forEach((v) => { delete v.__KEY__ });
        }
        this.props.onValueChanged(JSON.parse(JSON.stringify(source._items)))
    }
    onInitNewRow = (e) => {
        e.data.askUser = false;
        e.data.daysForAction = 0;
    }
    // onEditorPreparing = (e) => {
    //     if (e.dataField === 'daysForAction' && e.parentType === 'dataRow') {
    //         e.editorOptions.disabled = e.row?.data?.action !== 'CREATE';
    //     }
    // }
    // customizeItem = (item) => {
    //     if (item.dataField === "daysForAction") {
    //         const dataGridInstance = this.gridRef.current.instance;
    //         const editing = dataGridInstance.option('editing');
    //         const rowIndex = dataGridInstance.getRowIndexByKey(editing.editRowKey);
    //         item.disabled = !(dataGridInstance.cellValue(rowIndex, 'action') === "CREATE");
    //         console.log(dataGridInstance.cellValue(rowIndex, 'action'))

    //     }
    // }
    // onOptionChanged = (a, b, c) => {
    //     console.log(a, b, c)
    // }
    // setCellValue = (column, newData, object, currentRowData,a, b, c) => {
    //     // console.log(column, newData, object, currentRowData)
    // }
    render() {
        return (

            <DataGrid
                ref={this.gridRef}
                // key={this.props.id}
                // keyExpr="actionType"
                title="Post Actions"
                dataSource={this.state.items}
                showBorders={true}
                columnAutoWidth={true}
                onInitNewRow={this.onInitNewRow}
                onRowValidating={this.onRowValidating}
                // onEditorPreparing={this.onEditorPreparing}
                onRowInserted={this.updateParentList}
                onRowUpdated={this.updateParentList}
                onRowRemoved={this.updateParentList}
                repaintChangesOnly={true}
            >
                <Editing
                    mode="form"
                    allowUpdating={!this.props.readOnly}
                    allowAdding={!this.props.readOnly}
                    allowDeleting={!this.props.readOnly}
                    form={{
                        // customizeItem: this.customizeItem,
                        // onFieldDataChanged: this.onOptionChanged,
                        // onValueChanged: this.onOptionChanged,
                        // onOptionChanged: this.onOptionChanged
                    }}
                // useIcons={true}
                />
                <Column
                    dataField="action"
                    caption="Action"
                // setCellValue={this.setCellValue}
                >
                    <Lookup
                        dataSource={availableActions}
                    // displayExpr="display"
                    // valueExpr="value"
                    />
                    <RequiredRule />
                </Column>
                <Column
                    dataField="ownerParty"
                    caption="Owner Party"
                >
                    <Lookup
                        dataSource={availableParties}
                    // displayExpr="display"
                    // valueExpr="value"
                    />
                    <RequiredRule />
                </Column>
                <Column
                    dataField="actionType"
                    caption="Action Type"
                >
                    <Lookup
                        dataSource={this.state.availableActionOptions}
                        displayExpr="display"
                        valueExpr="value"
                    />
                    <RequiredRule />
                </Column>
                <Column
                    dataField="timePeriod"
                    caption="Time Period"
                >
                    <Lookup
                        dataSource={this.timePeriodOptions}
                    />
                    <RequiredRule />
                </Column>
                <Column
                    dataField="daysForAction"
                    dataType="number"
                    caption="Days"

                // setCellValue={this.setCellValue}
                >
                    <RequiredRule />

                    {/* <StringLengthRule message="Label must have 2 to 250 characters" min={2} max={250} /> */}
                </Column>
                <Column
                    dataField="askUser"
                    dataType="boolean"
                    caption="Ask User"
                >
                    {/* <StringLengthRule message="Label must have 2 to 250 characters" min={2} max={250} /> */}
                </Column>
            </DataGrid>
        );
    }


}


export default injectIntl(PostActionsGrid)